<div class="border-1 inline-flex items-center rounded px-8 py-4 uppercase" [attr.kind]="kind">
  <tsq-icon *ngIf="!!icon" [classes]="'w-16 h-16 mr-4'" [icon]="icon" />
  <span [tsqHighlight]="highlight" class="label-text mt-1">{{ text }}</span>
</div>
